// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import {  apiEndpoints } from "../../config";
import MediaLibrary from "../../partials/mediaLibrary";
import { get_csrf_token } from "../../core/auth";
import VideoPlayer from "./videoPlayer";

import { Button } from "@mui/material";

import PostEdit from "../../partials/posts/postEdit";

export default function VideoEdit() {
  const [post, setPost] = useState(null);
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [videoMid, setVideoMid] = useState(null);
  const [csrf_token, setCsrfToken] = useState(null);
  const user = useSelector((state) => state.authReducer.user);

  useEffect(() => {
    get_csrf_token().then((response) => setCsrfToken(response.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const extraFields = useMemo(
    () => (videoMid ? { field_video: videoMid } : {}),
    [videoMid],
  );

  return (
    <PostEdit
      apiEndpoint={apiEndpoints.videos}
      screenClassName={"videos"}
      categoryTitle={"Video category"}
      categoryName={"field_video_category"}
      targetVid={"video_categories"}
      returnRoute={"/videos-creator"}
      backBtnText={"Video Library"}
      previewRoute={"/videos/preview"}
      logCustomEventType={"Video"}
      extraFields={extraFields}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      <Button
        variant="outlined"
        component="label"
        size="small"
        onClick={() => setShowMediaLibrary(true)}
      >
        Open Media Library
      </Button>
      {(post?.mid !== null || selectedMedia) && (
        <VideoPlayer post={post} selectedMedia={selectedMedia} />
      )}
      {showMediaLibrary && (
        <MediaLibrary
          user={user}
          csrf_token={csrf_token}
          mediaType={"video"}
          showMediaLibrary={showMediaLibrary}
          setShowMediaLibrary={setShowMediaLibrary}
          onMediaInsert={(media) => {
            setVideoMid(media.mid);
            setSelectedMedia(media);
            setShowMediaLibrary(false);
          }}
        />
      )}
    </PostEdit>
  );
}
